export default __webpack_public_path__ + "static/media/signature_prison_nurse.bc4bacad.png";